import { BaseModel } from './base.model';

export class RawMaterialGroupModel extends BaseModel{
    id: number;
    uid: string;
    name: string;
}
